<template>
    <template v-if="isAdmin">
        <VJoyDropdown
            v-if="$ff('group-profile-admin-buttons-together')"
            class="profile-admin-wrapper__admin-panel-button"
            justify="right"
            :options="options"
            width="200"
            @update:model-value="(value) => dropdownItemClick(value as OptionId)"
        >
            <template #dropdown-button>
                <VJoyButton variant="admin" size="small" data-testid="admin-dropdown">Admin</VJoyButton>
            </template>
        </VJoyDropdown>
        <VJoyButton
            v-else
            class="profile-admin-wrapper__admin-panel-button"
            size="small"
            variant="admin"
            @click="eventBus.emit('dev-tools:edit-mode')"
        >
            Admin
        </VJoyButton>
        <AdminPanelSection />
        <VettingPanelSection :profile="profile as Profile" :wrapper-ref="scrollWrapper" />
    </template>
</template>
<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {toRef, useHasEnoughPriviledge, useTranslation} from '#imports';
    import {VJoyButton, VJoyDropdown} from '@maltjoy/core-vue';
    import AdminPanelSection from '~/components/edit/AdminPanelSection.vue';
    import VettingPanelSection from '~/components/edit/VettingPanelSection.vue';
    import {eventBus} from '~/config/events';
    import {useProfileStore} from '~/store/profileStore';
    import {type Profile} from '~/types/domain/Profile';

    type LazyAdminComponentsProps = {
        refToScrollTarget: HTMLElement | null;
    };

    const props = defineProps<LazyAdminComponentsProps>();

    // Composables
    const isAdmin = await useHasEnoughPriviledge(['ROLE_ADMIN']);
    const {t} = useTranslation();

    // Stores
    const profileStore = useProfileStore();
    const {profile} = storeToRefs(profileStore);
    const scrollWrapper = toRef(props, 'refToScrollTarget');

    type OptionId = 'admin' | 'panel-drawer';
    const options: {id: OptionId; label: string}[] = [
        {id: 'admin', label: 'Admin'},
        {id: 'panel-drawer', label: t('profile.vetting.drawer.button')},
    ];

    function dropdownItemClick(value: OptionId | undefined) {
        if (value === 'admin') {
            eventBus.emit('dev-tools:edit-mode');
        } else if (value === 'panel-drawer') {
            eventBus.emit('vetting:edit-mode');
        }
    }
</script>
<style lang="scss">
    .profile-admin-wrapper {
        &__admin-panel-button {
            &.joy-button,
            &.joy-dropdown {
                position: fixed;
                top: calc(var(--header-height) + var(--joy-core-spacing-5));
                right: var(--joy-core-spacing-5);
                z-index: 10;
            }
        }
    }
</style>
